import axios from "axios";
const api = axios.create({
  // baseURL: "http://localhost:8080/RAFScoreService",
  baseURL: "https://kl3uvldt17.execute-api.us-east-1.amazonaws.com/v1/health-care",
});
//Both URL should be same
export const url = "https://kl3uvldt17.execute-api.us-east-1.amazonaws.com/v1/health-care";

export default api;
